/**
 * @generated SignedSource<<39ba817220b7b4f4ac5e656263a9ad43>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type QuestionActions_Question$data = {
  readonly id: string;
  readonly rawId: number | null | undefined;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"RecordVideoButton_Question">;
  readonly " $fragmentType": "QuestionActions_Question";
};
export type QuestionActions_Question$key = {
  readonly " $data"?: QuestionActions_Question$data;
  readonly " $fragmentSpreads": FragmentRefs<"QuestionActions_Question">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "QuestionActions_Question",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rawId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RecordVideoButton_Question"
    }
  ],
  "type": "Question",
  "abstractKey": null
};

(node as any).hash = "58edb476ec2f4959851264aa542649be";

export default node;
